import type { ChangeEventHandler } from 'react';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
import { styled } from '@mui/material';

const StyledTextarea = styled(BaseTextareaAutosize)(() => ({
  padding: '0.625rem',
  border: 'solid 2px var(--c-line)',
  borderRadius: '4px',
  inlineSize: '100%',
  backgroundColor: 'transparent',
  '&:hover': {
    border: 'solid 2px var(--c-line)',
  },
  '&:focus': {
    border: 'solid 2px var(--c-line)',
    outline: 'none !important',
    boxShadow: 'none',
  },
}));

type Props = {
  minRows?: number;
  maxRows?: number;
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  value?: string;
};

export const TextareaAutosize = (props: Props) => {
  return (
    <>
      <StyledTextarea
        aria-label="textarea"
        minRows={props.minRows || 2}
        maxRows={props.maxRows || 4}
        onChange={props.onChange}
        value={props.value}
      ></StyledTextarea>
    </>
  );
};
